if( $('#pagina-provas').length ) {

    var vmProvas = new Vue({
        el: '#pagina-provas',
        data: {

            Filtros             : null, /* Classe Filtros, instanciada em created() */
            Paginacao           : null, /* Classe Paginacao, instanciada em created() */
            provas              : [],
            totalProvas         : -1,
            paginaAtual         : 1,
            inputPagina         : 1,
            ultimaPagina        : 1,
            provasPorPag        : 6, /* @todo Colocar pra 20 depois de tudo pronto */
            tempo               : 0,
            totalFiltrosAtivos  : 0,
            pId                 : -1,
            lightbox            : lity(),
            suspendeWatchs      : false,
            logado              : false,
            provaAResolver      : {
                grupo   : '',
                id      : -1
            },
            reportarProblema    : {
                titulo      : 'Relatar Problema em Prova',
                opcoes      : [
                    {   valor: 'dados',         texto: 'Dados Incorretos'   },
                    {   valor: 'duplicada',     texto: 'Prova Duplicada'    },
                    {   valor: 'edital',        texto: 'Edital Incorreto'   },
                    {   valor: 'gabarito',      texto: 'Gabarito Incorreto' },
                    {   valor: 'outro',         texto: 'Outro'              }
                ]
            },

            filtros : {
                grupos: {
                    nome: "grupos",
                    ativo: true,
                    selecionados: ["enem"],
                    opcoes: [
                        /*{valor: "concurso", texto: "Concursos"},*/
                        {valor: "enem", texto: "ENEM"}
                        /*{valor: "oab", texto: "OAB"},
                        {valor: "vestibular", texto: "Vestibulares"}*/
                    ]
                },
                palavras: {
                    nome: "palavras",
                    ativo: false,
                    selecionados: [],
                    opcoes: []
                },
                niveis: {
                    nome: "niveis",
                    ativo: false,
                    selecionados: [],
                    opcoes: [
                        {valor: "fundamental", texto: "Fundamental"},
                        {valor: "medio", texto: "Médio"},
                        {valor: "tecnico", texto: "Técnico"},
                        {valor: "superior", texto: "Superior"}
                    ]
                },
                orgaos: {
                    nome: "orgaos",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                },
                cargos: {
                    nome: "cargos",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                },
                bancas: {
                    nome: "bancas",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                },
                areasformacao: {
                    nome: "areasformacao",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                },
                areasconhecimento: {
                    nome: "areasconhecimento",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                },
                desde: {
                    nome: "desde",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                },
                ate: {
                    nome: "ate",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                }
            },
            maisopcoes: {
                nome: "maisopcoes",
                ativo: false,
                opcoes: {
                    transcritas: {dual: "naotranscritas", label: "Apenas Provas já Transcritas", valor: false},
                    naotranscritas: {dual: "transcritas", label: "Apenas Provas não Transcritas", valor: false}
                }
            }
        },
        methods: {
            adicionarNaColecao: function ( prova_id ) {

                if( ! this.logado  ){
                    return nav.open('register');
                }

                fechaTooltips();
                vmColecoes.abrirModal( prova_id, 'prova' );
            },
            compartilharProva: function ( prova_id ) {
                this.lightboxCompartilhar = lity();
                this.lightboxCompartilhar('#compartilhar-prova');

                var input = $('#input-compartilhar-prova');
                input.val('http://www.planetaensino.com/provas#p' + prova_id);
                input.on('click', function () {
                    $(this).select();
                })
            },
            relatarProblema: function ( prova_id ){

                if( ! this.logado  ){
                    return nav.open('register');
                }

                fechaTooltips();

                vmRelatarProblema.problemas = this.reportarProblema;
                vmRelatarProblema.urlAjax = '/provas/relatar-problema';
                vmRelatarProblema.abrirModal( prova_id );
            },
            resolverProva: function (grupo, prova_id) {
                this.provaAResolver.grupo = grupo;
                this.provaAResolver.id = prova_id;

                // Resolver questões avulsas ou em simulado?
                this.lightbox('#resolver-prova');
            },
            offset: function () {

                return (this.paginaAtual - 1) * this.provasPorPag;
            },
            consultaProva: function (hash) {

                var self = this;
                var pId = parseInt(hash.substring(2));

                ajaxGET('/provas/retorna-prova', {pId: pId}, function (retorno) {

                    self.totalProvas = retorno.totalProvas;
                    self.provas = retorno.provas;
                    self.tempo = retorno.tempo;

                    if (retorno.totalProvas > 0) {
                        self.filtros.grupos.selecionados = retorno.grupo;
                    }

                    Vue.nextTick(function () {
                        inicializaTooltips();
                    });
                });
            },
            sincronizaModelComServer: function (dadosServidor) {

                var self = this;
                this.totalProvas = dadosServidor.totalProvas;
                this.ultimaPagina = dadosServidor.ultimaPagina;
                this.provas = dadosServidor.provas;
                this.tempo = dadosServidor.tempo;

                Vue.nextTick(function () {
                    self.suspendeWatchs = false;
                    inicializaTooltips();
                });
            },
            carregaProvas: function (dadosAjax) {

                var self = this;
                this.suspendeWatchs = true;

                ajaxGET(
                    '/provas/filtrar',
                    dadosAjax,
                    function (dadosRetorno) {
                        self.sincronizaModelComServer(dadosRetorno);
                    }
                );

            }
        },
        computed: {
            totalFiltrosAtivos: function () {

                return this.Filtros.totalFiltrosAtivos('provas');
            },
            totalMaisOpcoesAtivas: function () {

                return this.Filtros.totalMaisOpcoesAtivas();
            }
        },
        created: function () {
            this.Filtros = new Filtros(this);
            this.Paginacao = new Paginacao(this);

            this.logado = $('#dlkjfasldgh').val() == '1';
        },
        ready: function () {

            /* Inicializando o Painel de Filtros */
            $('.botao-toggle-filtros').on('click', function () {
                $('.content').toggleClass('isOpen');
            });

            if (location.hash) {
                this.Filtros.verificaHash();
            } else {
                this.carregaProvas({grupos: this.filtros.grupos.selecionados});
            }

        }
    });


    /* SIMPLE JAVASCRIT ROUTER - BY RONI RIGONI */
    $(window).on('hashchange', function () {
        vmProvas.suspendeWatchs = true;
        vmProvas.Filtros.verificaHash();

    });


    vmProvas.$watch('filtros.grupos.selecionados', function (newVal, oldVal) {

        if (!this.suspendeWatchs) {

            var msgConfirmacao = false;

            /* Verifica se algum filtro dependente de AJAX foi selecionado */
            for( var filtroNome in this.filtros ){
                if( this.filtros[filtroNome].hasOwnProperty('carregando') &&
                    this.filtros[filtroNome].selecionados.length
                ){
                    msgConfirmacao = true;
                    break;
                }
            }

            if ( msgConfirmacao ) {
                this.Filtros.confirmaMudancaGrupo(oldVal);
            } else {
                this.Filtros.limparFiltrosAjax();
            }

        }

    });

    vmProvas.$watch('paginaAtual', function (newVal, oldVal) {

        if (!this.suspendeWatchs) {

            this.inputPagina = this.paginaAtual;

            this.Filtros.filtrar();
        }

    });

}
